import { Component, OnInit, ViewChild } from '@angular/core';
import { AccountScheduleMain } from 'src/app/models/CalendarRequest';
import { OptionSet } from 'src/app/models/OptionSet';
import { Schedule_ep } from 'src/app/models/Schedule_ep';
import { CalendarService } from 'src/app/services/calendar.service';
import { EnumDirectionType } from '../../schedule-list/schedule-list.component';
import { ScheduleGridComponent } from '../schedule-grid/schedule-grid.component';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-institution-schedule',
  templateUrl: './institution-schedule.component.html',
  styleUrls: ['./institution-schedule.component.scss']
})
export class InstitutionScheduleComponent implements OnInit {
  @ViewChild(ScheduleGridComponent) scheduleGrid: ScheduleGridComponent;
  public newAccountSchedule: AccountScheduleMain;

  dirty: boolean = false;
  loading: boolean = false;
  disableButton: boolean;

  constructor(public calendarSvc: CalendarService,public dataService: DataService) {
    //this.calendarSvc.getMainAccountSchedule();
    this.calendarSvc.spinnerSubjectEmit(true);
    this.disableButton = !this.dirty || this.loading;
    this.calendarSvc.accountScheduleSubject.subscribe(() => {
      debugger
      this.disableButton = !this.calendarSvc.accountSchedule || (this.calendarSvc.accountSchedule.Id_e != null && this.calendarSvc.accountSchedule.Id_p != null);
      //this.scheduleGrid.conditionsToInitial++;
      this.scheduleGrid.initForm(this.calendarSvc.accountSchedule, true);
      this.scheduleGrid.focusFirstInput();
    });
  }

  ngOnInit() {

  }

  cancel() {
    this.scheduleGrid.resetForm();
  }

  save() {
    debugger;
    // this.loading = true;
    this.calendarSvc.spinnerSubjectEmit(true);

    Object.keys(this.scheduleGrid.form.controls).forEach(key => {
      var value = this.scheduleGrid.form.get(key).value;     
        var option = this.calendarSvc.ScheduleHoursList.find(x => x.value == value);
        this.calendarSvc.accountSchedule[key] = option   
    });
    this.calendarSvc.saveAccountSchedule(this.calendarSvc.accountSchedule).then((res: any) => {
      this.loading = false;
      this.disableButton = !this.dirty || this.loading;
      if (!this.dataService.IsError(res)) {
      var guids = JSON.parse(res);
      this.calendarSvc.accountSchedule.Id_e = guids["Id_e"];
      this.calendarSvc.accountSchedule.Id_p = guids["Id_p"];
      this.calendarSvc.accountScheduleSubject.next();
      this.calendarSvc.spinnerSubjectEmit(false);
    }
    }).catch(err => {
      this.loading = !this.dirty || this.loading;
      alert("ארעה שגיאה");
    });
  }

  // save() {
  //   debugger;
  //   this.newAccountSchedule = new AccountScheduleMain();
  //   console.log(this.scheduleGrid.form);
  //   Object.keys(this.scheduleGrid.form.controls).forEach(key => {
  //     var day = key.substring(0, key.indexOf("_"));
  //     var value = this.scheduleGrid.form.get(key).value;
  //     if (value != null) {
  //       var option = this.calendarSvc.ScheduleHoursList.find(x => x.viewValue == value);
  //       if (key.endsWith('e'))
  //         this.newAccountSchedule.schedule_e[day] = option
  //       else this.newAccountSchedule.schedule_p[day] = option
  //     }
  //   });
  //   debugger;
  //   this.newAccountSchedule.schedule_e.Id = this.accountSchedule.Id_e;
  //   this.newAccountSchedule.schedule_e._Type = new OptionSet();
  //   this.newAccountSchedule.schedule_e._Type.value = EnumDirectionType.איסוף.toString();
  //   this.newAccountSchedule.schedule_p.Id = this.accountSchedule.Id_p;
  //   this.newAccountSchedule.schedule_p._Type = new OptionSet();
  //   this.newAccountSchedule.schedule_p._Type.value = EnumDirectionType.פיזור.toString();
  //   console.log(this.newAccountSchedule);
  //   this.calendarSvc.saveAccountSchedule(this.newAccountSchedule).then((res: any )=> {
  //     var guids = JSON.parse(res);

  //   }).catch(err => {
  //     debugger;
  //   });
  // }

  setButtonsAvailability(isDirty: boolean) {
    if (isDirty) {
      this.dirty = true;
      this.disableButton = !this.dirty || this.loading;
    }
    else {
      this.dirty = false;
      this.disableButton = !this.dirty || this.loading;
    }
  }

}
